<script>
  export default {
    name: 'TheHeader'
  }
</script>

<template>
  <header class="header">
    <b-container>
      <div class="header__logo">
        <h1>
          <img src="https://static.ciclic.com.br/svg/ciclic-logo.svg" alt="Logo Ciclic" />
        </h1>
      </div>
    </b-container>
  </header>
</template>

<style lang="scss" scoped>
  .header {
    position: sticky;
    top: 0;
    left: 0;
    padding: 11px 0;
    background: white;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.04);

    &__logo {
      width: 100%;
      max-width: 110px;

      > h1 {
        line-height: 0;
        margin: 0;
      }
    }
  }
</style>
